// theme.ts

export const theme = {
  fontFamily: "'Open Sans', sans-serif",
  fontSizes: {
    xs: '12px',
    sm: '13px',
    md: '14px',
    lg: '16px',
    xl: '1.25rem',
  },
  text: {
    primary: '#676A6C',
    secondary: '#2B2B2B',
    dark: '#263949',
    link: '#2F4050',
    linkBlue: '#49B6E7',
    muted: '#9C9FA2',
    error: '#DF5353',
  },
  colors: {
    primary: '#83CF9C',
    white: '#FFFFFF',
    accent: '#19AA8D',
    background: {
      icon: 'rgba(38, 57, 73, 0.12)',
    },
  },
  border: {
    main: '#D0D0D0',
    light: '#E8E8E8',
    input: '#C7C8CA',
  },
};